/**
 * SISTEMA DE AUTENTICAÇÃO COMPARTILHADO
 * Funções para validar sessão e controlar acesso
 */

import SessionStorage from './storage.js';

class AuthSystem {
    
    /**
     * Verifica se o usuário está logado
     * @returns {boolean} - true se logado, false se não
     */
    static isAuthenticated() {
        // Verifica se existe sessão ativa
        const hasSession = SessionStorage.hasActiveSession();
        
        // Verifica se a sessão não expirou (opcional)
        const isExpired = SessionStorage.isSessionExpired();
        
        if (hasSession && !isExpired) {
            console.log('✅ Usuário autenticado');
            return true;
        }
        
        // Se expirou, limpa a sessão
        if (isExpired) {
            console.log('⏰ Sessão expirada, fazendo logout...');
            this.logout();
        }
        
        console.log('❌ Usuário não autenticado');
        return false;
    }

    /**
     * Realiza login do usuário (salva sessão)
     * @param {Object} userData - Dados do usuário do backend
     * @returns {boolean} - true se sucesso, false se erro
     */
    static login(userData) {
        if (!userData || !userData.userId) {
            console.error('❌ Dados de usuário inválidos');
            return false;
        }

        const success = SessionStorage.setUserSession(userData);
        
        if (success) {
            console.log('✅ Login realizado com sucesso');
            return true;
        }
        
        return false;
    }

    /**
     * Realiza logout do usuário (limpa sessão)
     */
    static logout() {
        SessionStorage.clearSession();
        console.log('✅ Logout realizado');
    }

    /**
     * Obtém dados do usuário logado
     * @returns {Object|null} - Dados do usuário ou null
     */
    static getCurrentUser() {
        return SessionStorage.getUserSession();
    }

    /**
     * Verifica se usuário tem permissão específica
     * @param {string} permission - Nome da permissão
     * @returns {boolean} - true se tem permissão, false se não
     */
    static hasPermission(permission) {
        const user = this.getCurrentUser();
        
        if (!user || !user.permissions) {
            return false;
        }
        
        return user.permissions.includes(permission);
    }

    /**
     * Verifica se usuário tem role específico
     * @param {string} role - Nome do role
     * @returns {boolean} - true se tem o role, false se não
     */
    static hasRole(role) {
        const user = this.getCurrentUser();
        
        if (!user || !user.role) {
            return false;
        }
        
        return user.role === role;
    }

    /**
     * Força redirecionamento para login se não autenticado
     * Esta função será chamada em cada página para garantir segurança
     */
    static requireAuth() {
        if (!this.isAuthenticated()) {
            console.log('🔒 Acesso negado - redirecionando para login');
            
            // Redirecionamento direto para evitar dependência circular
            const loginUrl = '../../LoginInicial/public/index.html';
            window.location.href = loginUrl;
            
            return false;
        }
        
        return true;
    }
}

export default AuthSystem;